<template>
  <div
    class="Bar2Charts"
    ref="loading-box"
    :loading="loading"
    element-loading-text="拼命加载中..."
    element-loading-background="rgba(0, 0, 0, 0)"
    :class="{ link: isOpenLink && !isEditMode ? true : false }"
    @mousedown="!isEditMode && isOpenLink && echartClick($event)"
  >
    <div class="echarts" :id="Configuration.id"></div>
    <div class="no-data" v-if="noData">
      <sapn>暂无数据！</sapn>
    </div>
  </div>
</template>

<script>
import * as Echarts from 'echarts';
import { getFilterValue, jumpSomePlaceByLink } from '../../../../utils/tool';
import { mapState } from 'vuex';
import { request } from '../../../../common/request';
export default {
  name: 'Bar2Charts',
  components: {},
  props: {
    ProjectInfo: Object,
    Configuration: Object,
  },
  data() {
    return {
      echartsOptions: {},
      apiIntervalTaskID: null,
      staticIntervalTaskID: null,
      loading: true, // 加载对象
      noData: false,
    };
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function() {
        if (this.Configuration.isScaling) {
          this.throttle_resizeEcharts();
        } else if (this.Configuration.isMoving) {
          this.debounce_resizeEcharts();
        } else {
          this.debounce_subscribeConfigurationChange();
        }
      },
    },
  },
  created() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    this.registerDebounceAndThrottle();
  },
  mounted() {
    this.$nextTick(() => {
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    });
    // this.getApiDataResByFilterAndResponseQuery();
    this.setStyle();
  },
  beforeUnmount() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    this.destroyEcharts();
    this.unRegisterDebounceAndThrottle();
  },
  computed: {
    ...mapState({ isEditMode: state => state.isEditMode }),
    isOpenLink() {
      return this.Configuration.propertyData?.chartLink?.value?.isOpenLink;
    },
    style() {
      return this.ProjectInfo.Style.componentName;
    },
  },
  methods: {
    getFilterValue(e) {
      return getFilterValue(e);
    },
    // 根据不同的风格取不同的颜色
    setStyle() {
      let color;
      switch (this.style) {
        case 'V1Style':
          color = '#eee';
          break;
        case 'V2Style':
          color = '#eee';
          break;
        case 'V3Style':
          color = '#7fdfff';
          break;
        case 'V4Style':
          color = '#b044f8';
          break;
        case 'V5Style':
          color = '#09af60';
          break;
        default:
          color = '#eee';
          break;
      }
      this.$refs['loading-box'].style.setProperty('--color', color); // 给变量赋值
    },
    registerDebounceAndThrottle() {
      this.debounce_resizeEcharts = this.$_.debounce(this.resizeEcharts, 100);
      this.debounce_subscribeConfigurationChange = this.$_.debounce(this.subscribeConfigurationChange, 500);
      this.throttle_resizeEcharts = this.$_.throttle(this.resizeEcharts, 20);
    },
    unRegisterDebounceAndThrottle() {
      this.debounce_resizeEcharts.cancel();
      this.debounce_subscribeConfigurationChange.cancel();
      this.throttle_resizeEcharts.cancel();
    },
    // 订阅Configuration变化将会执行的函数
    subscribeConfigurationChange() {
      clearInterval(this.apiIntervalTaskID);
      clearInterval(this.staticIntervalTaskID);
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    },
    setEchartsOptions(ParamData = null) {
      this.loading = true;
      if (Object.keys(ParamData).length == 0 || ParamData.source.length == 0) {
        this.noData = true;
      } else {
        this.noData = false;
      }
      let grid = {};
      let chartColor = [];
      let cUnit = {};
      let source = [];
      let seriesList = [];
      let unit = '';
      let backgroundColor = '';
      let fontStyle = {
        titleColor: '#ccc',
        titleSize: 16,
        xAxisColor: '#c3dbff',
        xAxisSize: 12,
        yAxisColor: '#c3dbff',
        yAxisSize: 12,
      };

      if (this.Configuration.propertyData.chartsColor.value.chartColor) {
        chartColor = this.Configuration.propertyData.chartsColor.value.chartColor;
      }
      if (this.Configuration.propertyData?.chartUnit?.value) {
        unit = this.Configuration.propertyData.chartUnit.value;
      }
      if (this.Configuration.propertyData.chartsGrid.value) {
        grid = this.Configuration.propertyData.chartsGrid.value;
      }
      if (ParamData && ParamData.source && ParamData.seriesList) {
        source = ParamData.source;
        seriesList = ParamData.seriesList;
      }
      if (this.Configuration.propertyData.fontStyle.value) {
        fontStyle = this.Configuration.propertyData.fontStyle.value;
      }
      if (this.Configuration.propertyData.ChartBackground.value) {
        backgroundColor = this.Configuration.propertyData.ChartBackground.value;
      }
      if (this.Configuration.propertyData.chartsUnit?.value) {
        cUnit = this.Configuration.propertyData.chartsUnit.value;
      }

      console.log(source);
      console.log(seriesList);

      let rangeTime = [];
      let rangeData = [];
      let rangeDataValue = [];
      // 判断时间格式 '09:00-11:00'
      var regex = /^([01]\d|2[0-3]):([0-5]\d)-([01]\d|2[0-3]):([0-5]\d)$/;
      function DealData() {
        seriesList.forEach(s => {
          source.forEach(item => {
            if (s === item.s) {
              if (regex.test(item.x)) {
                rangeTime.push(item.x);
                rangeData.push({
                  time: item.x,
                  value: item.y,
                });
              } else if (typeof item.x === 'number') {
                rangeTime.push(item.x + ':00');
                rangeData.push({
                  time: item.x + ':00',
                  value: parseInt(item.y),
                });
              } else {
                rangeTime.push(new Date(item.x).getHours() + ':00');
                rangeData.push({
                  time: new Date(item.x).getHours(),
                  value: parseInt(item.y),
                });
              }

              rangeDataValue.push(parseInt(item.y));
            }
          });
        });
      }
      DealData();
      // 关闭加载
      this.$nextTick(() => {
        // this.loading.close();
        this.loading = false;
        // console.log('关闭加载', this.loading.close);
      });

      this.echartsOptions = {
        backgroundColor: this.Configuration.propertyData.chartsColor.value.chartBackgroundColor,
        animationEasing: 'quarticOut',
        animationDelay: function() {
          return 0;
        },
        title: {
          text: '',
          subtext: '',
        },
        tooltip: {
          className: 'echarts-tooltip echarts-tooltip-dark',
          //提示框组件，鼠标悬浮在图表上，有相应提示框
          show: true,
          trigger: 'axis',
          axisPointer: {
            type: 'shadow', //可选line、shadow、none
            shadowStyle: {
              // 鼠标悬浮图表柱状图背景色
              color: '#484d5259',
              width: '1',
            },
          },
          textStyle: {
            color: '#fff',
            fontSize: this.$h_Ratio(15, this.$store),
          },
        },
        grid: {
          //直角坐标系，图表的位置参数
          ...grid,
          containLabel: true, //grid 区域是否包含坐标轴的刻度标签。
          //这常用于『防止标签溢出』的场景，标签溢出指的是，标签长度动态变化时，可能会溢出容器或者覆盖其他组件。
        },
        xAxis: {
          show: false, //是否显示x轴
          position: 'bottom', //x轴显示在哪 只有top和bottom选项
          offset: 0, //x轴相对默认位置的偏移

          type: 'value', //1.value 数值轴 2.category类目轴 3.time 时间轴 4.log对数轴
          // data:echartData,    //x轴数据放人数
          data: rangeDataValue,
          axisLine: {
            //坐标轴线的相关设置 不用动 已经默认隐藏
            lineStyle: {
              color: '#a09fa3',
            },
            show: false, //是否显示坐标轴线
            symbol: 'none', //坐标轴的箭头，默认不显示，可选rect、circle、pin、arrow
            //symbolSize:[11,11]  箭头符号的尺寸
          },
          axisTick: {
            //坐标轴的刻度相关设置 不用动 默认隐藏
            show: false, //是否显示
            alignWidthLabel: false, //刻度线和柱子是否对齐
            inside: false, //刻度是否朝内，true为朝外
            length: 5, //刻度线的长度
            //lineStyle样式{ color , width , type , shadowBlur , shadowColor , shadowOffsetX , shadowOffsetY , opacity }
          },
          axisLabel: {
            //刻度标签的设置（刻度下面的文字）
            show: false,
            interval: 0, //刻度标签显示的间隔
            rotate: 0, //刻度标签旋转的角度，在类目轴的类目标签显示不下的时候可以通过旋转防止标签之间重叠。
            margin: 10, //刻度与轴线之间的距离
            //color: "rgba(235, 172, 55, 1)",//标签文字颜色
            width: 10, //文字的宽度
            clickable: false,
            textStyle: {
              //文字样式
              color: '#a09fa3',
              fontFamily: 'Arial, Verdana, sans-serif',
              fontSize: 16,
              fontStyle: 'normal',
              fontWeight: 'normal',
            },
          },
          splitLine: {
            //每根柱子的分隔线，默认不显示
            show: false,
            onGap: null,
            lineStyle: {
              color: '#030e19',
              type: 'solid',
              shadowColor: 'rgba(0,0,0,0)',
              shadowBlur: 5,
              shadowOffsetX: 3,
              shadowOffsetY: 3,
            },
          },
        },
        yAxis: [
          {
            name: '',
            type: 'category',
            name: unit,
            data: rangeTime, //////纵坐标放时间
            nameTextStyle: {
              color: '#fff',
              nameLocation: 'start',
              fontSize: this.$h_Ratio(fontStyle.xAxisSize, this.$store),
              padding: [cUnit.top, cUnit.right, cUnit.bottom, cUnit.left],
            },
            axisLine: {
              //纵坐标轴线 不显示
              lineStyle: {
                color: '#a09fa3',
              },
              show: false,
            },
            axisTick: {
              //纵坐标轴的刻度 不显示
              show: false,
            },
            axisLabel: {
              //纵坐标刻度标签文字
              show: true,
              interval: 'auto',
              rotate: 0,
              margin: 8,
              clickable: false,
              // formatter: '{value}',
              textStyle: {
                color: fontStyle.yAxisColor,
                align: '',
                fontFamily: 'Arial, Verdana, sans-serif',
                fontSize: this.$h_Ratio(fontStyle.yAxisSize, this.$store),
                fontStyle: 'normal',
                fontWeight: 'normal',
              },
            },
            // splitNumber:6, //坐标轴分隔的段数，这只是个预估值，实际显示会以具体数据为准，可增加
            splitLine: {
              show: false,
              onGap: null,
              lineStyle: {
                color: '#a09fa3',
                type: 'solid',
                shadowColor: 'rgba(0,0,0,0)',
                shadowBlur: 5,
                shadowOffsetX: 3,
                shadowOffsetY: 3,
              },
            },
          },
        ],
        series: [
          //这里放图表的数据
          {
            // 柱子背景色
            showBackground: backgroundColor,
            backgroundStyle: {
              color: '#031d46',
            },
            name: seriesList[0],
            type: 'bar', //图表类型
            // data:echartData, //图表具体数据，这里通过echartData获取
            data: rangeDataValue,
            barGap: '-100%', // 两条柱条重叠
            itemStyle: {
              //图表样式
              normal: {
                color: params => {
                  // console.log(params);
                  var data = rangeDataValue;
                  data.sort(function(a, b) {
                    return a - b;
                  });
                  data.reverse();
                  var statusIndex = 0;
                  data.forEach(function(event, index) {
                    if (event == params.data) {
                      statusIndex = index;
                    }
                  });
                  var colorList = [...chartColor];
                  var colorList2 = [];
                  chartColor.forEach(item => {
                    let c = this.$tinycolor(item)
                      .setAlpha(0.05)
                      .toRgbString();
                    colorList2.push(c);
                  });
                  var color = new Echarts.graphic.LinearGradient(1, 0, 0, 0, [
                    {
                      offset: 0,
                      color: colorList[statusIndex % 6],
                    },
                    {
                      offset: 1,
                      color: colorList2[statusIndex % 6],
                    },
                  ]);
                  return color; //大概最新的柱子颜色始终一样的 不太理解
                },
                label: {
                  //柱状图显示数字
                  show: true, //开启显示
                  position: 'right', //在上方显示
                  textStyle: {
                    //数值样式
                    color: fontStyle.xAxisColor,
                    fontSize: this.$h_Ratio(fontStyle.xAxisSize, this.$store),
                  },
                },
                borderWidth: 2,
                barBorderRadius: 15,
              },
            },
            barWidth: this.$h_Ratio(4, this.$store), //柱子宽度，根据不同屏幕判断柱子大小不同
            barMaxWidth: 30,
            animationEasing: 'quarticOut', //动画
            animationDelay: function() {
              return 0;
            },
          },
        ],
      };
    },
    // 开启静态任务 数据是静态的
    startStaticIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let chartsAnimation = this.Configuration?.propertyData?.chartsAnimation?.value;
      if (ChartsData?.currenEntry === 'staticData' && chartsAnimation?.isUseStaticRefresh) {
        // console.log('使用静态任务');
        let func = () => {
          this.setEchartsOptions(ChartsData.staticData);
          this.$nextTick(() => {
            this.createEcharts();
          });
        };
        clearInterval(this.staticIntervalTaskID);
        func();

        this.staticIntervalTaskID = setInterval(() => {
          console.log('任务执行staticData');
          console.log(chartsAnimation);
          func();
        }, chartsAnimation?.staticRefreshIntervalTime * 1000);
      } else if (ChartsData?.currenEntry === 'staticData') {
        console.log('无静态任务 执行staticData');
        this.setEchartsOptions(ChartsData.staticData);
        this.$nextTick(() => {
          this.createEcharts();
        });
      }
    },
    // 开启api动态任务 数据是动态的
    async startApiIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      // 判断是否使用apiData，使用动态interval请求
      if (ChartsData?.currenEntry === 'apiData' && ChartsData?.apiData?.isUseInterval) {
        // 开启interval任务 间隔请求
        let func = async () => {
          let res = await this.getApiDataResByFilterAndResponseQuery();
          this.setEchartsOptions(res);
          this.$nextTick(() => {
            this.createEcharts();
          });
        };
        func();
        this.apiIntervalTaskID = setInterval(async () => {
          // console.log('开启interval任务 间隔请求');
          func();
        }, ChartsData?.apiData?.apiInterval * 1000);
        // console.log(ChartsData?.apiData?.apiInterval);
      } else if (ChartsData?.currenEntry === 'apiData') {
        // console.log('不开启interval任务 只处理一次请求');
        let res = await this.getApiDataResByFilterAndResponseQuery();
        this.setEchartsOptions(res);
        this.$nextTick(() => {
          this.createEcharts();
        });
      }
    },
    // promise 返回api链接的请求数据
    getApiDataRes() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let that = this;
      return new Promise((resolve, reject) => {
        if (!ChartsData) resolve('Error ChartsData 不存在！');
        if (!ChartsData.apiData?.apiUrl) resolve('Error apiUrl 不存在！');
        let header;
        if (ChartsData.apiData?.isUseUserKey) {
          let user_key = localStorage.getItem('user_key');

          if (user_key == 'undefined' || user_key == 'null' || user_key == null) user_key = this.$userKey;
          header = {
            userkey: user_key,
          };
        } else {
          header = {};
        }
        if (ChartsData.apiData?.apiUrlMethod == 'get') {
          let params = ChartsData.apiData.apiPostParams || '{}';
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: eval('(' + params + ')'),
            headers: header,
          };

          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        } else {
          let params = ChartsData.apiData.apiPostParams || '{}';
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            data: eval('(' + params + ')'),
            headers: header,
          };

          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery
    getApiDataResByResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery和过滤器函数
    getApiDataResByFilterAndResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        let filter = function(data, filter_text) {
          let dataSet = {};
          eval(filter_text);
          return dataSet;
        };
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // 判断是否使用过滤器
            if (ChartsData.apiData.isUseFilter) {
              res = filter(res, ChartsData.apiData.apiFilter);
            }
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 创建 Echarts 需要准备好echartsOptions数据 具有reload效果
    createEcharts() {
      this.destroyEcharts();
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.init(mychartDom, 'dark');
      mychart.setOption(this.echartsOptions);
    },
    // 自适应缩放 Echarts 尺寸大小
    resizeEcharts() {
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.getInstanceByDom(mychartDom);
      if (mychart) {
        mychart.resize();
      }
    },
    // 更新 echartsOptions 数据
    updateEcharts() {
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.getInstanceByDom(mychartDom);
      if (mychart) {
        mychart.setOption(this.echartsOptions);
      } else {
        this.createEcharts();
      }
    },
    // 销毁 Echarts 实例
    destroyEcharts() {
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.getInstanceByDom(mychartDom);
      if (mychart) {
        mychart.clear();
        mychart.dispose();
      }
    },
  },

  Configuration: {
    componentTitle: '横向时间柱状图',
    componentName: 'Bar2Charts',
    componentOverViewImg: './img/charts/BarCharts/Bar2Charts.png',
    id: '',
    style: {
      width: 300,
      height: 150,
      left: 0,
      top: 0,
    },
    isScaling: false,
    isMoving: false,
    propertyData: {
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },
      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts1Border',
        },
      },
      chartsColor: {
        propertyComponentName: 'ArrayColorSelector',
        value: {
          chartColor: [
            'rgba(223,65,56,1)',
            'rgba(229,115,63,1)',
            'rgba(240,189,108,1)',
            'rgba(237,214,102,1)',
            'rgba(77,168,222,1)',
            'rgba(25,168,164,1)',
          ],
          chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
        },
      },
      ChartsData: {
        lable: '数据接入',
        propertyComponentName: 'ChartsDataConfigor',
        value: {
          currenEntry: 'staticData',
          apiData: {
            apiUrl:
              'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
            // apiUrl:
            // 'http://192.168.0.173/gthmmc_v4.0/gthmmc/index.php?m=sdms&c=dataMange&a=completeStatisticsdata&data=%7B%22type%22:%22%E6%80%BB%E6%95%B0%22,%22date_start%22:%222021-03-01%22,%22date_end%22:%222021-03-31%22%7D&directory_code=pro_ownerstatistics&type=day',
            apiResponseQuery: 'data.forecasts',
            isUseFilter: true,
            apiFilter: `
          // 可以使用data访问api请求的响应结果        
let seriesList = []

let seriesListKey = 'city'
let seriesListChildrenKey = 'casts'

data.forEach((item) => {
  seriesList.push(item[seriesListKey])
})
dataSet.seriesList = seriesList
dataSet.source = []
data.forEach((item) => {
  item[seriesListChildrenKey].forEach(item2 => {
    dataSet.source.push({
      s: item[seriesListKey],
      x: item2.date,
      y: item2.daytemp
    })
  })
})
          `,
            isUseInterval: true,
            apiInterval: 10,
            apiUrlMethod: 'get',
            apiPostParams: '',
          },
          staticData: {
            seriesList: ['人数'],
            source: [
              {
                s: '人数',
                y: '122',
                x: '2021-06-02 12:10:51',
                i: 1,
              },
              {
                s: '人数',
                y: '67',
                x: '2021-06-02 11:10:51',
                i: 2,
              },
              {
                s: '人数',
                y: '55',
                x: '2021-06-02 09:10:51',
                i: 3,
              },
              {
                s: '人数',
                y: '34',
                x: '2021-06-02 08:10:51',
                i: 4,
              },
              {
                s: '人数',
                y: '12',
                x: '2021-06-02 07:10:51',
                i: 5,
              },
            ],
          },
        },
      },
      // 链接
      chartLink: {
        propertyComponentName: 'ChartsLinkConfiger',
        value: {
          isOpenLink: false, // 是否开启链接
          linkType: 'inner', // 链接类型 inner内链场景、outer外链地址
          linkUrl: '', // 链接url ，inner时是场景的id、outer时是http地址
        },
      },
      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 300,
          height: 150,
          left: 0,
          top: 0,
        },
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#ccc',
          xAxisSize: 12,
          xAxisColor: '#c3dbff',
          yAxisSize: 12,
          yAxisColor: '#c3dbff',
        },
      },
      chartsGrid: {
        lable: '图表定位',
        propertyComponentName: 'ChartsGridConfiger',
        value: {
          left: '5%',
          right: '10%',
          bottom: '5%',
          top: '5%',
        },
      },
      chartsUnit: {
        lable: '单位定位',
        propertyComponentName: 'ChartsUnitConfiger',
        value: {
          left: '10',
          right: '0',
          bottom: '0',
          top: '0',
        },
      },
      chartUnit: {
        propertyComponentName: 'MapChartUnit',
        value: '单位(张)',
      },
      showStatus: {
        value: 'norm',
      },
      chartsOpicity: {
        propertyComponentName: 'ChartsOpicityConfiger',
        value: 1,
      },
      chartsAnimation: {
        propertyComponentName: 'ChartsAnimationConfiger',
        value: {
          isUseAnimation: false,
          isUseStaticRefresh: false,
          staticRefreshIntervalTime: 5,
        },
      },
      ChartBackground: {
        propertyComponentName: 'ChartBackgroundConfiger',
        value: true,
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.Bar2Charts {
  color: white;
  width: 100%;
  height: 100%;

  .echarts {
    width: 100%;
    height: 100%;
  }
  .no-data {
    width: 100%;
    height: 100%;
    /* // background: #000; */
    position: absolute;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #a9a9a9;
  }
}

// 加载样式

:deep().el-loading-spinner {
  .path {
    stroke: var(--color) !important;
  }

  p {
    display: flex !important;
    align-items: center !important;
    color: var(--color) !important;
  }
}
.link {
  // cursor:pointer;
  :deep()canvas {
    &:hover {
      // pointer-events: auto;
      cursor: pointer;
    }
  }
}
</style>
